import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const FooterWrapper = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  @media ${device.tablet} {
    flex-direction: column;
    align-items: flex-start;
    > button:not(:first-child) {
      margin-left: 0 !important;
      margin-top: 15px !important;
    }
  }
`;

export const FooterArrows = styled.div`
  flex: auto;
  display: flex;
  justify-content: flex-end;
`;

export const ArrowUp = styled.button`
  width: 40px;
  height: 40px;
  font-weight: 700;
  border-radius: 4px;
  background-color: rgb(251, 206, 55);
  border: 0px none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 1px solid rgba(50, 39, 1, 0.3);
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  > svg {
    fill: #322701;
    width: 20px;
    height: 20px;
  }
`;

export const ArrowDown = styled.button`
  width: 40px;
  height: 40px;
  font-weight: 700;
  border-radius: 4px;
  background-color: rgb(251, 206, 55);
  border: 0px none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  > svg {
    fill: #322701;
    width: 20px;
    height: 20px;
  }
`;

export const FooterOkBtn = styled.button`
  position: relative;
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  border: none;
  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
  padding: 6px 14px;
  background-color: rgb(251, 206, 55);

  border-radius: 4px;
  min-height: 40px;
  color: rgb(50, 39, 1);
  font-weight: 700;
  font-size: 18px;
`;

export const FooterPressText = styled.span`
  color: rgb(71, 69, 64);
  margin-left: 14px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  @media ${device.tablet} {
    display: none;
  }
`;
